import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Action, select, Store } from '@ngrx/store';
import * as fromCustomer from '../reducers';
import * as customer from '../actions/customer';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { CustomersService } from '../services/customers.service';
import { withPredicateFrom } from '../../core/helpers/rx-pipes';

@Injectable()
export class CustomerEffects {
  constructor(
    private actions$: Actions,
    private store: Store<fromCustomer.State>,
    private customerService: CustomersService
    ) {}

    @Effect()
    getCustomers$: Observable<Action> =
      this.actions$.ofType<customer.Get>(customer.GET)
        .pipe(
          switchMap(() => {
            return this.customerService.getCustomers()
              .pipe(
                map(customers => new customer.GetSuccess(customers)),
                catchError(e => of(new customer.GetFailed(e)))
              )
          })
        )

    @Effect()
    expand$: Observable<Action> =
      this.actions$.ofType<customer.Expand>(customer.EXPAND)
        .pipe(
          withPredicateFrom(
            this.store.pipe(select(fromCustomer.customersCanExpand)),
            canExpand => canExpand
          ),
          withLatestFrom(
            this.store.pipe(select(fromCustomer.getCustomerSearchTerm)),
            this.store.pipe(select(fromCustomer.getNextCustomerPage)),
            (action, searchTerm, nextPage) => ({ searchTerm, nextPage })
          ),
          switchMap(data => {
            return this.customerService.getCustomers(data.nextPage, data.searchTerm)
              .pipe(
                map(customers => new customer.ExpandSuccess(customers)),
                catchError(e => of(new customer.ExpandFailed(e)))
              )
          })
        )

    @Effect()
    search$: Observable<Action> =
      this.actions$.ofType<customer.Search>(customer.SEARCH)
        .pipe(
          withLatestFrom(
            this.store.pipe(select(fromCustomer.getCustomerSearchTerm)),
            this.store.pipe(select(fromCustomer.getNextCustomerPage)),
            (action, searchTerm, nextPage) => ({ searchTerm, nextPage })
          ),
          switchMap(data => {
            return this.customerService.getCustomers(1, data.searchTerm)
              .pipe(
                map(customers => new customer.SearchSuccess(customers)),
                catchError(e => of(new customer.SearchFailed(e)))
              )
          })
        )
}
